/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { VscCircleFilled } from "react-icons/vsc";
import { ChartOptions } from "chart.js";
import { useQuery } from "react-query";
import {
  MonitorDashboardAgentChartApi,
  MonitorDashboardApi,
  MonitorDashboardCampaignChartApi,
  UserCampaignListApi,
  UserCampaignNumbersApi,
  UserListApi,
} from "../../Api";
import { AxiosResponse } from "axios";
import {
  CampaignCustomersNumberType,
  CampaignsDataType,
  MonitorAgentChartDataType,
  MonitorAgentCompareChartType,
  MonitorCampaignChartDataType,
  MonitorDashboardDataType,
  TotalOnlineUsersType,
} from "../../type";
import { Link } from "react-router-dom";
import { FaUsers } from "react-icons/fa";
import { TbMessage2Down, TbMessage2Up } from "react-icons/tb";
import { MdCampaign } from "react-icons/md";
import { Line, Bar, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import socket from "../../socket";
import HelpText from "../../../Components/HelpText";
import { formatDate } from "../../../helper";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface CampaignIdType {
  chart: number | null;
  list: number | null;
}

interface FilterType {
  CampaignChart: null | number;
  AgentChart: null | number;
  AgentCompareChart: null | number;
}

export default function MonitorDashboard() {
  const [CampaignCustomersNumber, setCampaignCustomersNumber] =
    useState<CampaignCustomersNumberType[]>();
  const [campaignId, setCampaignId] = useState<CampaignIdType>({
    chart: null,
    list: null,
  });
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [dashboardData, setDashboardData] =
    useState<MonitorDashboardDataType>();
  const [CampaignChart, setCampaignChart] = useState<
    MonitorCampaignChartDataType[]
  >([]);
  const [AgentChartData, setAgentChartData] = useState<
    MonitorAgentChartDataType[]
  >([]);
  const [AgentCompareChart, setAgentCompareChart] = useState<
    MonitorAgentCompareChartType[]
  >([]);
  const [Campaigns, setCampaigns] = useState<CampaignsDataType[]>([]);
  const [filter, setFilter] = useState<FilterType>({
    CampaignChart: null,
    AgentChart: null,
    AgentCompareChart: null,
  });
  const [users, setUsers] = useState<{ id: number; name: string }[]>([]);

  const [TotalOnlineUsers, setTotalOnlineUsers] = useState<TotalOnlineUsersType[]>([]);


  const ITEMS_PER_PAGE = 5; // Adjust as needed
  const [currentPage, setCurrentPage] = useState(1);
  const totalItems = TotalOnlineUsers.length;
  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);

  // Get the users to display on the current page
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentPageData = TotalOnlineUsers.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  // Function to handle page change
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const RecentNumbers = useQuery({
    queryKey: ["User-Campaign-Numbers-API", campaignId.list],
    queryFn: UserCampaignNumbersApi,
    onSuccess: (resp: AxiosResponse) => {
      setCampaignCustomersNumber(resp.data?.CampaignCustomersNumber || []);
    },
    enabled: false,
  });

  const { refetch } = useQuery({
    queryKey: ["Monitor-Dashborad-API"],
    queryFn: MonitorDashboardApi,
    onSuccess: (resp: AxiosResponse) => {
      setDashboardData(resp.data);
      setCampaignChart(resp?.data?.CampaignChartData || []);
      setAgentChartData(resp?.data?.AgentChartData || []);
      setAgentCompareChart(resp?.data?.AgentCompareChart || []);
    },
    enabled: false,
  });

  const userCampaignList = useQuery({
    queryKey: ["User-Campaign-List-API"],
    queryFn: UserCampaignListApi,
    onSuccess: (resp: AxiosResponse) => {
      setCampaigns(resp.data?.CampaignList || []);
    },
    enabled: false,
  });

  const userList = useQuery({
    queryKey: ["User-List-API"],
    queryFn: UserListApi,
    onSuccess: (resp: AxiosResponse) => {
      setUsers(resp.data?.users || []);
    },
    enabled: false,
  });

  const CampaignChartData = useQuery({
    queryKey: ["Monitor-Dashborad-Campaign-Chart-API", filter.CampaignChart],
    queryFn: MonitorDashboardCampaignChartApi,
    onSuccess: (resp: AxiosResponse) => {
      setCampaignChart(resp.data?.CampaignChartData || []);
    },
    enabled: false,
  });

  const AgentChart = useQuery({
    queryKey: ["Monitor-Dashborad-Agent-Chart-API", filter.AgentChart],
    queryFn: MonitorDashboardAgentChartApi,
    onSuccess: (resp: AxiosResponse) => {
      setAgentChartData(resp.data?.AgentChartData || []);
    },
    enabled: false,
  });

  useEffect(() => {
    RecentNumbers.refetch();
    // eslint-disable-next-line
  }, [campaignId.list]);

  useEffect(() => {
    refetch();
    userCampaignList.refetch();
    userList.refetch();
  }, []);

  useEffect(() => {
    CampaignChartData.refetch();
  }, [filter.CampaignChart]);

  useEffect(() => {
    AgentChart.refetch();
  }, [filter.AgentChart]);

  useEffect(() => {
    socket.emit("Users");
    socket.on("Users", (resp: any) => {
      setTotalOnlineUsers(resp)
    });
    return () => {
      socket.off("Users");
    }
  }, [])

  const generateColors = (count: number) => {
    const colors = [];
    for (let i = 0; i < count; i++) {
      colors.push(`#${Math.floor(Math.random() * 16777215).toString(16)}`);
    }
    return colors;
  };

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Pie chart configuration
  const options: ChartOptions<"pie"> = {
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        callbacks: {
          label: function (tooltipItem: any) {
            const dataset = tooltipItem.dataset;
            const dataIndex = tooltipItem.dataIndex;
            const total = dataset.data.reduce(
              (sum: number, value: number) => sum + value,
              0
            );
            const currentValue = dataset.data[dataIndex];
            const percentage = ((currentValue / total) * 100).toFixed(2);
            const label = tooltipItem.chart.data.labels[dataIndex];

            return [`${label}: ${percentage}%`, `Value ${currentValue}`];
          },
        },
      },
      legend: {
        position: screenWidth < 776 ? "top" : "right", // Adjust legend position based on screen width
        labels: {
          font: {
            size: 14,
          },
          generateLabels: (chart: any) => {
            const data = chart.data;
            if (!data.labels || !data.datasets.length) return [];

            const total = data.datasets[0].data
              .filter((value: any): value is number => typeof value === "number")
              .reduce((sum: any, value: number) => sum + value, 0);

            return data.labels.map((label: any, index: number) => {
              const value = data.datasets[0].data[index] as number | undefined;
              if (value === undefined) return null;

              const percentage = ((value / total) * 100).toFixed(2);

              const backgroundColor = Array.isArray(data.datasets[0].backgroundColor)
                ? data.datasets[0].backgroundColor[index]
                : undefined;

              const borderColor = Array.isArray(data.datasets[0].borderColor)
                ? data.datasets[0].borderColor[index]
                : undefined;

              return {
                text: `${label}: ${percentage}%  value:${value}`,
                fillStyle: backgroundColor,
                strokeStyle: borderColor,
                hidden: !chart.getDataVisibility(index),
                index,
              };
            }).filter(Boolean);
          },
        },
      },
    },
    // Set only one `responsive` option
    responsive: true,
  };


  return (
    <>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Monitor Dashboard</h1>
            </div>
          </div>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">
          {/* 4 Box */}
          <div className="row">
            <div className="col-xl-3 col-sm-6 col-12">
              <Link
                to={""}
                className="small-box bg-warning cursor-pointer text-decoration-none"
              >
                <div className="inner">
                  <h3>{dashboardData?.TotalAgents || 0}</h3>
                  <p>Total Agents</p>
                </div>
                <div className="icon">
                  <FaUsers />
                </div>
              </Link>
            </div>
            <div className="col-xl-3 col-sm-6 col-12">
              <Link
                to={""}
                className="small-box bg-danger cursor-pointer text-decoration-none"
              >
                <div className="inner">
                  <h3>{dashboardData?.TotalCampaign || 0}</h3>
                  <p>Total Campaign</p>
                </div>
                <div className="icon">
                  <MdCampaign />
                </div>
              </Link>
            </div>
            <div className="col-xl-3 col-sm-6 col-12">
              <Link
                to={""}
                className="small-box bg-info cursor-pointer text-decoration-none"
              >
                <div className="inner">
                  <h3>{dashboardData?.TotalOutgoingSMS || 0}</h3>
                  <p>Total Outgoing</p>
                </div>
                <div className="icon">
                  <TbMessage2Up />
                </div>
              </Link>
            </div>
            <div className="col-xl-3 col-sm-6 col-12">
              <Link
                to={""}
                className="small-box bg-dark cursor-pointer text-decoration-none"
              >
                <div className="inner">
                  <h3>{dashboardData?.TotalIncomingSMS || 0}</h3>
                  <p>Total Incoming</p>
                </div>
                <div className="icon">
                  <TbMessage2Down className="text-white-50" />
                </div>
              </Link>
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-xl-6">
              <div className="card">
                <div className="card-header bg-white w-100 d-flex flex-wrap gap-2 align-items-center">
                  <h2 className="fs-5 mb-0 flex-grow-1">
                    Recent SMS Received Numbers
                  </h2>
                  <select
                    style={{ width: 240 }}
                    value={!campaignId.list ? "All" : campaignId.list}
                    className="form-control"
                    onChange={(e) => {
                      if (e.target.value === "All")
                        return setCampaignId({ ...campaignId, list: null });
                      setCampaignId({
                        ...campaignId,
                        list: Number(e.target.value),
                      });
                    }}
                  >
                    <option value="All">All</option>
                    {Campaigns?.map((item, i) => (
                      <option key={i} value={item?.id?.toString()}>
                        {item?.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <table className="table table-hover mb-0 table-bordered text-nowrap">
                      <thead>
                        <tr>
                          <th className="ps-3 sr-no">SR No</th>
                          <th style={{ minWidth: 200 }}>Number</th>
                          <th style={{ width: 100 }} className="text-center">
                            Unread
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {CampaignCustomersNumber?.length ? (
                          CampaignCustomersNumber?.map((item, i) => (
                            <tr key={i}>
                              <td className="ps-3">{i + 1}</td>
                              <td>{item?.from}</td>
                              <td className="text-center">
                                {item?.unread_count}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={5}
                              className="text-center fs-5 fw-semibold"
                            >
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-6">
              <div className="card">
                <div className="card-header bg-white p-3">
                  <div className="d-flex align-items-center justify-content-between">
                    <h2 className="fs-5 mb-0">Agent and Customer Realtime Overview</h2>
                    <VscCircleFilled className="text-success fs-4" />
                  </div>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <table className="table table-hover mb-0 table-bordered text-nowrap">
                      <thead>
                        <tr>
                          <th className="ps-3 sr-no">SR No</th>
                          <th>User Name</th>
                          <th>Campaign Name</th>
                          <th>Number</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentPageData.length > 0 ? (
                          currentPageData.map((item, index) => (
                            <React.Fragment key={item.user_id}>
                              <tr>
                                {/* User Information */}
                                <td className="ps-3">{startIndex + index + 1}</td>
                                <td>{item.user_name}</td>
                                <td className="px-0 p-0">
                                  {item.campaign.length > 0 ? (
                                    <table className="table table-sm  border-start-0 mb-0 w-100">
                                      <tbody>
                                        {item.campaign.map((campaign, idx) => (
                                          <tr key={idx} className="border-0">
                                            <td className="border border-start-0 border-end-0 ps-2" style={{ width: "60%" }}>{campaign.campaign_name}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  ) : (
                                    <span className="text-muted">No Campaign Available</span>
                                  )}
                                </td>
                                <td className="px-0 p-0">
                                  {item.campaign.length > 0 ? (
                                    <table className="table table-sm  border-start-0 mb-0 w-100">
                                      <tbody>
                                        {item.campaign.map((campaign, idx) => (
                                          <tr key={idx} className="border-0">
                                            <td className="border border-start-0 border-end-0 ps-2" style={{ width: "40%" }}>{campaign.number}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  ) : (
                                    <span className="text-muted">No Campaign Available</span>
                                  )}
                                </td>

                              </tr>
                            </React.Fragment>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={4} className="text-center fs-5 fw-semibold">
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {/* Pagination Controls */}
                  {currentPageData.length > 0 &&
                    (
                      <div className="">
                        <div className="pagination justify-content-center py-3">
                          <button
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="btn border rounded-end-0 text-secondary me-1 mt-2"
                          >
                            Previous
                          </button>
                          {[...Array(totalPages)].map((_, index) => (
                            <button
                              key={index}
                              onClick={() => handlePageChange(index + 1)}
                              className={`btn border rounded-0 me-1 mt-2 ${currentPage === index + 1 ? 'btn-primary' : 'btn-outline-secondary'}`}
                            >
                              {index + 1}
                            </button>
                          ))}
                          <button
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="btn border rounded-start-0 text-secondary mt-2"
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    )
                  }
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-2">
            {/* Chart */}
            <div className="col-xl-6">
              <div className="card">
                <div className="card-header bg-white w-100 d-flex flex-wrap gap-2 align-items-center">
                  <h5 className="m-0 flex-grow-1">
                    SMS traffic
                    <span className="fs-6 text-secondary">(Current Year)</span>
                  </h5>
                  <select
                    style={{ width: 240 }}
                    value={!filter.CampaignChart ? "All" : filter.CampaignChart}
                    className="form-control"
                    onChange={(e) => {
                      if (e.target.value === "All")
                        return setFilter({
                          ...filter,
                          CampaignChart: null,
                        });
                      setFilter({
                        ...filter,
                        CampaignChart: Number(e.target.value),
                      });
                    }}
                  >
                    <option value="All">All</option>
                    {Campaigns?.map((item, i) => (
                      <option key={i} value={item?.id?.toString()}>
                        {item?.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="card-body">
                  <div className="responsive-charts">
                    <Line
                      data={{
                        labels: CampaignChart.map((item) => item.month),
                        datasets: [
                          {
                            label: "Outgoing",
                            data: CampaignChart.map((item) =>
                              parseInt(item.Outbound, 10)
                            ),
                            borderColor: "rgba(75,192,192,1)",
                            backgroundColor: "rgba(75,192,192,0.2)",
                            fill: true,
                            tension: 0.1,
                          },
                          {
                            label: "Incoming",
                            data: CampaignChart.map((item) =>
                              parseInt(item.Inbound, 10)
                            ),
                            borderColor: "rgba(153,102,255,1)",
                            backgroundColor: "rgba(153,102,255,0.2)",
                            fill: true,
                            tension: 0.1,
                          },
                        ],
                      }}
                      options={{ responsive: true, maintainAspectRatio: false }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-6">
              <div className="card">
                <div className="card-header bg-white w-100 d-flex flex-wrap gap-2 align-items-center">
                  <h5 className="m-0 flex-grow-1">
                    User Outgoing
                    <span className="fs-6 text-secondary">(Current Year)</span>
                  </h5>
                  <select
                    style={{ width: 240 }}
                    value={!filter.AgentChart ? "All" : filter.AgentChart}
                    className="form-control"
                    onChange={(e) => {
                      if (e.target.value === "All")
                        return setFilter({
                          ...filter,
                          AgentChart: null,
                        });
                      setFilter({
                        ...filter,
                        AgentChart: Number(e.target.value),
                      });
                    }}
                  >
                    <option value="All">All</option>
                    {users?.map((item, i) => (
                      <option key={i} value={item?.id?.toString()}>
                        {item?.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="card-body">
                  <div className="responsive-charts">
                    <Line
                      data={{
                        labels: AgentChartData.map((item) => item.month),
                        datasets: [
                          {
                            label: "Outgoing",
                            data: AgentChartData.map((item) =>
                              parseInt(item.Outbound, 10)
                            ),
                            borderColor: "rgba(75,192,192,1)",
                            backgroundColor: "rgba(75,192,192,0.2)",
                            fill: true,
                            tension: 0.1,
                          },
                        ],
                      }}
                      options={{ responsive: true, maintainAspectRatio: false }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-xl-6 h-100">
              <div className="card">
                <div className="card-header bg-white w-100 d-flex flex-wrap gap-2 align-items-center">
                  <h5 className="m-0 flex-grow-1">
                    User Compare
                    <span className="fs-6 text-secondary">(Current Year)</span>
                  </h5>
                </div>
                <div className="card-body">
                  <div className="responsive-charts">
                    {AgentCompareChart.length > 0 ? (
                      <Pie
                        data={{
                          labels: AgentCompareChart.map((item) => item.user?.name),
                          datasets: [
                            {
                              label: "Outgoing",
                              data: AgentCompareChart.map((item) =>
                                parseInt(item.Outbound, 10)
                              ),
                              backgroundColor: [
                                '#FF6384', '#36A2EB', '#FFCE56', '#FF5733', '#D4AC3C',
                                '#1F618D', '#A569BD', '#5D6D7E', '#F39C12', '#C0392B',
                                ...generateColors(AgentCompareChart.length - 10),
                              ],
                            },
                          ],
                        }}
                        options={options}
                      />
                    ) : (
                      <p className="text-center d-flex flex-column h-100 justify-content-center mb-0 fw-semibold fs-5">
                        No data Found
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section >
    </>
  );
}
